<div class="viewport-1">
  <background #background></background>
  <img id="fil-logo" class="overlay-fil-logo" [class.fade-out]="goToStartAnimation" src="/assets/images/wordflight_vrt_color_pos_rgb.svg" />
  @if (!restrictLogin) {
    <div id="login-box" class="login-form-wrapper" [class]="{'pop-out': loggedIn, 'hidden': showUsage }">
      @if (alertStatus !== AlertStatus.HIDDEN) {
        <div id="failedLoginDisplay" class="alert custom-alert font-15"
          [class]="{'alert-info': alertStatus === AlertStatus.INFO, 'alert-danger': alertStatus === AlertStatus.ERROR}"
          >
          {{result}}
        </div>
      }
      <label class="login-text-label">Login</label>
      <form name="studentLoginForm" class="form login-form" [formGroup]="loginForm" (ngSubmit)="login()">
        @if (capsOn) {
          <div class="caps-lock-warning">
            <div><img src="/assets/images/caps-lock.svg" height="16" width="16" /></div>
            <div>Caps-lock is enabled</div>
          </div>
        }
        <div class="login-grid">
          <label class="login-label-username login-field-text font-27" for="username">Username</label>
          <input class="login-input-username login-field font-27" type="text" id="username" name="username" formControlName="username" required autofocus>
          <label class="login-label-password login-field-text font-27" for="password">Password</label>
          <input class="login-input-password login-field font-27" [type]="showPassword() ? 'text' : 'password'" id="password" name="password" formControlName="password" required>
          <button class="login-button-show-password" type="button" (click)="toggleShowPassword()" aria-label="toggle show password">
            <fa-icon [icon]="showPasswordIcon()" size="xl" aria-label="Toggle show password"></fa-icon>
          </button>
          <button class="login-button clear-btn btn-login" type="submit" [disabled]="!loginForm.valid || loginButtonDisabled" aria-label="login"></button>
        </div>
      </form>
      <div class="login-clever">
        <a [href]="cleverOauth"><img src="/assets/images/LogInWithClever.svg" width="207"/></a>
        <a [href]="classlinkOauth"><img src="/assets/images/LogInWithClassLink.png" style="width: 207px;" /></a>
      </div>
    </div>
  }
  @if (restrictLogin) {
    <div class="download-element-message" style="font-weight: bold ; font-size: 2rem ;">
      <div>
        WordFlight works best on mobile devices and tablets when using the WordFlight app, get it now...
      </div>
      <div class="download-app-wrapper">
        <div class="download-app-btn">
          <a [href]="appStoreLink"><img src="/assets/images/app-icon.png" width="48" height="48"/> WordFlight</a>
        </div>
      </div>
    </div>
  }
  <div class="usage-element-message" [hidden]="!showUsage">
    <p>
      Hi! You’ve been really active with WordFlight this week, and you’ve hit your weekly time limit.
      Congratulations on your hard work. We’ll see you next week!
    </p>
    <button class="btn btn-success" (click)="cancelLogin()">See you then</button>
  </div>
  <version-footer [class.fade-out]="goToStartAnimation"></version-footer>
</div>
